import apiHandler from "../core/apiHandler";

/**
 * 🪪 QZ Tray Certificate API
 * Maneja todas las peticiones relacionadas con los certificados digitales
 * usados para firmar tickets o payloads desde QZ Tray.
 */
const qzTrayCertificateApi = apiHandler("qztray/certificates");

export default qzTrayCertificateApi;
